import React, { useEffect } from 'react';
export function EquipmentRepaintingPage() {
  useEffect(() => {
    // Redirect to Motor City Truck Collision in a new window
    window.open('https://www.motorcitytruckcollision.com/', '_blank');
    // Optionally redirect back to home page after opening the new window
    // Uncomment the line below if you want to redirect back to home
    // window.location.href = '/'
  }, []);
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center" data-id="element-4463">
      <div className="text-center" data-id="element-4464">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-[#B1050B] mx-auto mb-4" data-id="element-4465"></div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-4466">
          Redirecting to Motor City Truck Collision...
        </h1>
        <p className="text-gray-600" data-id="element-4467">
          If you are not redirected automatically,{' '}
          <a href="https://www.motorcitytruckcollision.com/" target="_blank" rel="noopener noreferrer" className="text-[#B1050B] hover:underline font-semibold" data-id="element-4468">
            click here
          </a>
        </p>
      </div>
    </div>;
}